/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-05-21 17:22:46
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-28 11:21:48
 */
const getters = {
  token: state => state.user.token,
  simpleToken: state => state.user.simpleToken,
  jwtDecode: state => state.user.jwtDecode,
  userInfo: state => state.user.userInfo,
  salaryPass: state => state.user.salaryPass,
  showSalaryPass: state => state.user.showSalaryPass,
  checkedEsign: state => state.user.checkedEsign,
  card_type: state => state.user.card_type,
  card_id: state => state.user.card_id,
  wechatAutoLoginTime: state => state.user.wechatAutoLoginTime,
  wechatAutoLoginTimeFlag: state => state.user.wechatAutoLoginTimeFlag,
  browserUA: state => state.user.browserUA,
  enterRoute: state => state.user.enterRoute,
  ecompanyCode: state => state.user.ecompanyCode,
  ocompanyCode: state => state.user.ocompanyCode,
  partnerToken: state => state.partner.partnerToken,
  partnerJwtDecode: state => state.partner.partnerJwtDecode,
  taskOrder: state => state.user.taskOrder,
  requestCounter: state => state.user.requestCounter,
  enterRouteLoading: state => state.user.enterRouteLoading,
  customerServiceObjClose: state => state.custom.customerServiceObjClose,
  customerServiceObjPhoneNumber: state => state.custom.customerServiceObjPhoneNumber,
  mobileDefaultAvatar: state => state.custom.mobileDefaultAvatar,
  loadingImg: state => state.custom.loadingImg
};
export default getters
